/**
 * Created by Administrator on 2017/4/24.
 */
var merge = require('webpack-merge');
import Vue from 'vue';

var config = {
  "STORAGE_TOKEN_NAME": "stoken",
  "STORAGE_USER": "suser",
  "COOKIE_TOKEN_NAME": "ctoken",//延期使用
  "COOKIE_LOGIN_TOKEN": "ltoken",
  defaultLoginType: 1 //1:跳转 2:弹出 3:微信授权
};

if (process.env.NODE_ENV === 'production') {
  config = merge(config, {
    domain: {
      "forensicsBackstage": "https://bs.ebaoquan.org", //证据官网后台接口
      "forensicsWebOp": "https://i.ebaoquan.org", //证据官网后台接口
      "athenaBackstage": "https://bs.wbq360.com", //原创官网后台接口
      "athenaWebUms": "https://i.wbq360.com",  //原创官网后台页面
      "accountWeb": "https://account.ebaoquan.org", //账户中心
      "athenaFront": "https://www.wbq360.com", //原创官网页面
      "portal": "https://www.ebaoquan.org",  //易保全官网
      "junziqianWebOp": "https://web.junziqian.com",
      "jzqBackstage": "https://s.junziqian.com", //君子签后台
      "rtcDomain": "https://rtc.ebaoquan.com",
    }
  });
} else if (process.env.NODE_ENV === 'sandbox') {
  config = merge(config, {
    domain: {
      "forensicsBackstage": "http://bs.sandbox.ebaoquan.org", //证据官网后台接口
      "forensicsWebOp": "http://i.sandbox.ebaoquan.org", //证据官网后台接口
      "athenaBackstage": "http://bs.sandbox.wbq360.com",
      "athenaWebUms": "http://i.sandbox.wbq360.com",
      "accountWeb": "https://account-sandbox.ebaoquan.org",
      "athenaFront": "http://sandbox.wbq360.com",
      "portal": "http://sandbox.ebaoquan.org",
      "junziqianWebOp": "http://web.sandbox.junziqian.com",
      "jzqBackstage": "http://s.sandbox.junziqian.com",
      "rtcDomain": "https://rtc-sandbox.ebaoquan.com",
    }
  });
  console.log(config);
} else {
  config = merge(config, {
    domain: {
      "forensicsBackstage": "http://bs.sandbox.ebaoquan.org", //证据官网后台接口
      // "forensicsBackstage" : "http://192.168.169.101:8090", //证据官网后台接口
      "forensicsWebOp": "http://i.ebaoquan.test:81", //证据官网后台接口
      "athenaBackstage": "http://bs.sandbox.wbq360.com",
      "athenaWebUms": "http://i.sandbox.wbq360.com",
      "accountWeb": "https://account-sandbox.ebaoquan.org",
      // "accountWeb" : "http://account.ebaoquan.test:8080",
      "athenaFront": "http://sandbox.wbq360.com",
      "portal": "http://sandbox.ebaoquan.org",
      "junziqianWebOp": "http://web.sandbox.junziqian.com",
      "jzqBackstage": "http://s.sandbox.junziqian.com",
      "rtcDomain": "https://rtc-sandbox.ebaoquan.com",
    }
  });
}
module.exports = config;
Vue.prototype.globalConfig = config;




// WEBPACK FOOTER //
// ./src/common/js/GlobalConfig.js